import { ScrollReveal } from "@components/motion/Transitioned"
import { ContentItemDetailed, ContentItemDetailedSlim, ContentItemSlim } from "@components/site/ContentItem"
import { defineBlock, EditableText } from "eddev/blocks"
import { Fragment } from "react/jsx-runtime"

export const meta: BlockMeta = {
  title: "Selected Content",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/selected-content", (props) => {
  // return null
  return (
    <ScrollReveal>
      <div className="w-grid mx-auto flex flex-col gap-7 py-7 my-10">
        <EditableText as="p" store="title" className="type-label-l md:type-label-xl" placeholder="Optional Title" />
        <div className="w-full flex flex-col gap-5" data-transition="children/fade">
          {env.admin && props.results?.length === 0 && (
            <div className="w-full p-8 rounded-lg bg-grey flex items-center justify-center type-label-m">
              Select content
            </div>
          )}
          {props.results?.map(
            (item, index) =>
              !!item && (
                <Fragment key={index}>
                  {props.style === "slim" && <ContentItemSlim item={item} index={index} />}
                  {props.style === "detailed" && <ContentItemDetailed item={item} />}
                  {props.style === "detailedslim" && <ContentItemDetailedSlim item={item} />}
                </Fragment>
              ),
          )}
        </div>
      </div>
    </ScrollReveal>
  )
})
